import { useEffect, useRef, useState } from 'react';
import { useLocalStorageState } from '../local-storage.hooks';
import debounce from 'lodash/debounce';
import {
  EquipmentDmgFilterType,
  EquipmentLocalStorage,
} from '@/entities/equipment';

interface EquipmentFilterProps {
  setCurrentPage: (page: number) => void;
}

export const useEquipmentFilter = ({
  setCurrentPage,
}: EquipmentFilterProps) => {
  const [debouncedFilter, setDebouncedFilter] =
    useState<EquipmentDmgFilterType>({ key: '' });
  const filtersEmptyRef = useRef<boolean>(true);

  /**
   * === Filter section ===
   */
  const [key, setKey] = useLocalStorageState({
    key: EquipmentLocalStorage.KEY,
    removeOnClose: true,
  });

  const [status, setStatus] = useLocalStorageState({
    key: EquipmentLocalStorage.STATUS,
    removeOnClose: true,
  });

  const [isMultiple, setIsMultiple] = useLocalStorageState({
    key: EquipmentLocalStorage.IS_MULTIPLE,
    removeOnClose: true,
  });

  const searchByMultipleEquipments = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = (event.target as HTMLInputElement).checked;
    setIsMultiple(value?.toString());
    setCurrentPage(1);
    setDebouncedFilter((prev) => ({ ...prev, isMultiple: value }));
  };

  useEffect(() => {
    setDebouncedFilter((prev) => ({
      ...prev,
      key: key || '',
      status,
      isMultiple: isMultiple === 'true',
    }));

    filtersEmptyRef.current = !key && !status && !isMultiple;
  }, [key, status, isMultiple]);

  const debounceFilterUpdate = (value: string) => {
    setKey(value);
    setCurrentPage(1);
    debounce((value: string) => {
      setDebouncedFilter((prev) => ({ ...prev, key: value }));
    }, 1000);
  };

  const searchByStatus = (value: string) => {
    setStatus(value);
    setCurrentPage(1);
    setDebouncedFilter((prev) => ({ ...prev, status: value }));
  };

  const clearFilters = () => {
    setKey('');
    setStatus('');
    setIsMultiple('');
    setCurrentPage(1);
  };
  /**
   * === END OF Filter section ===
   */

  return {
    debouncedFilter,
    filtersEmpty: filtersEmptyRef.current,
    clearFilters,
    key,
    status,
    isMultiple,
    debounceFilterUpdate,
    searchByStatus,
    searchByMultipleEquipments,
  };
};
